export default "__VITE_ASSET__DdQzg6PR__"